const home = "/home";
const customerList = "/customerlist";
const usermanagement = "/usermanagement";
const customerCreate = "/customercreate";
const userCreate = "/userCreate";
const vehiclelist = "/vehiclelist";
const carmanagement = "/carmanagement";
const adduser = "/adduser";
const WorkStationManagement = "/workstationmanagement";
const OrgUserManagement = "/orgusermanagement";
const vehicleManagement = "/vehiclemanagement";
const uservehiclelist = "/uservehiclelist";
const scheduledtasks = "/scheduledtasks";
const basicInfo = "/basicinfo";
const visualization = "/visualization";
const datastatistics = "/datastatistics";
const operate = "/operate";
const cardatastatistics = "/cardatastatistics";
const cardatastatisticsdetail = "/cardatastatisticsdetail";
const securityset = "/securityset";
const usermanage = "/usermanage";
const unattendedList = "/unattendedList";
const vehiclecontrol = "/vehiclecontrol";
const dashboard = "/dashboard";

export default {
  home,
  customerList,
  usermanagement,
  customerCreate,
  adduser,
  userCreate,
  vehiclelist,
  uservehiclelist,
  vehicleManagement,
  WorkStationManagement,
  OrgUserManagement,
  carmanagement,
  scheduledtasks,
  basicInfo,
  visualization,
  datastatistics,
  operate,
  cardatastatistics,
  cardatastatisticsdetail,
  securityset,
  usermanage,
  unattendedList,
  vehiclecontrol,
  dashboard,
};
